import React from 'react';
import { ArrowTopRightOnSquareIcon, CheckBadgeIcon } from '@heroicons/react/24/outline';

const Certificates = ({ certificates }) => {
  if (!certificates || certificates.length === 0) {
    return null;
  }

  const sortedCertificates = [...certificates].sort(
    (a, b) => {
      if (a.display_order && b.display_order) {
        return a.display_order - b.display_order;
      }

      return new Date(b.date_issued) - new Date(a.date_issued);
    }
  );

  const latestAwsIds = sortedCertificates
    .filter((certificate) => certificate.issuer.includes('Amazon Web Services'))
    .slice(0, 3)
    .map((certificate) => certificate.id);

  return (
    <section className="bg-dark-800 py-20">
      <div className="container mx-auto max-w-7xl px-4">
        <div className="mb-12 max-w-3xl">
          <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-primary-300">
            Credentials
          </p>
          <h2 className="text-3xl font-bold text-white sm:text-4xl">Recent AWS Certifications</h2>
          <p className="mt-4 text-lg leading-8 text-gray-400">
            Current professional development focused on AWS operations, serverless delivery, and cloud fundamentals.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
          {sortedCertificates.map((certificate) => {
            const isLatestAws = latestAwsIds.includes(certificate.id);

            return (
              <a
                key={certificate.id}
                href={certificate.credential_url}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex h-full flex-col rounded-lg border border-dark-600 bg-dark-900 p-6 shadow-lg transition-colors hover:border-primary-500"
              >
                <div className="flex items-start justify-between gap-4">
                  <div>
                    {isLatestAws && (
                      <span className="mb-3 inline-flex items-center rounded-full bg-primary-500/10 px-3 py-1 text-xs font-semibold text-primary-200">
                        <CheckBadgeIcon className="mr-1 h-4 w-4" />
                        Latest AWS credential
                      </span>
                    )}
                    <h3 className="text-xl font-bold leading-7 text-white group-hover:text-primary-300">
                      {certificate.title}
                    </h3>
                  </div>
                  <ArrowTopRightOnSquareIcon className="mt-1 h-5 w-5 flex-none text-gray-500 group-hover:text-primary-300" />
                </div>

                <p className="mt-3 text-sm text-gray-400">
                  <span className="font-semibold text-gray-300">{certificate.issuer}</span>
                  <span className="text-gray-500"> | {certificate.date_issued}</span>
                </p>

                <p className="mt-4 flex-grow text-sm leading-6 text-gray-300">
                  {certificate.description}
                </p>

                {certificate.image && (
                  <div className="mt-6 flex items-center border-t border-dark-600 pt-5">
                    <div className="flex h-20 w-20 items-center justify-center">
                      <img
                        src={certificate.image}
                        alt={certificate.title}
                        className="h-20 w-20 object-contain"
                      />
                    </div>
                    <span className="ml-4 text-sm font-medium text-primary-300">View credential</span>
                  </div>
                )}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Certificates;
